const index = {
  root: {
    flexGrow: 1,
    padding: "0px 10rem 0px 10rem"
  }
}

export default index